// Model.js
// -----------------------
// @module Case
define("Ames.ConfigurableItems.COnfigurablePDP.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/COnfigurablePDP/SuiteScript2/COnfigurablePDP.Service.ss"
            ),
            true
        )
});
});
